if (!customElements.get('pf-review-ticker')) {
  customElements.define('pf-review-ticker', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.handlePause = () => {
        const paused = this.toggleAttribute('data-paused');
        this.button.textContent = paused ? 'Play' : 'Pause';
        this.button.setAttribute('aria-label', paused ? 'Resume scrolling reviews' : 'Pause scrolling reviews');
        this.button.setAttribute('aria-pressed', String(paused));
      };
      this.button?.addEventListener('click', this.handlePause);
      this.resizeObserver = new ResizeObserver(() => {
        const width = this.querySelector('.pf-ticker-set')?.scrollWidth || 0;
        this.style.setProperty('--pf-ticker-duration', `${Math.max(30, width / 35)}s`);
      });
      this.resizeObserver.observe(this);
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handlePause);
      this.resizeObserver?.disconnect();
    }
  });
}
